import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';

import conf from '../../../shared/conf.js';

class LinkAs extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    do: PropTypes.string.isRequired,
    freelance: PropTypes.string.isRequired,
    notConnected: PropTypes.string.isRequired,
  };

  static defaultProps = {
    className: '',
    notConnected: null,
  };

  generateLink = (link) => {
    let linkTag = null;
    if ((typeof link) === 'string') {
      linkTag = <Link to={link} className={this.props.className}>{this.props.children}</Link>;
    } else if ((typeof link) === 'function') {
      linkTag = <Link onClick={link} to="#" className={this.props.className}>{this.props.children}</Link>;
    }
    return linkTag;
  };

  render() {
    const {notConnected, user, ...props} = this.props;

    let link = null;
    if (!user) {
      if (notConnected) {
        link = this.generateLink(notConnected);
      }
    } else {
      if (conf.accountTypes.freelance === user.account_type) {
        link = this.generateLink(props.freelance);
      } else if(conf.accountTypes.do === user.account_type) {
        link = this.generateLink(props.do);
      }
    }

    if (link === null) {
      link = <Link to="#" className={props.className}>{props.children}</Link>;
    }

    return link;
  }
}

export default connect(
  state => ({
    user: state.currentUser.user
  })
)(LinkAs);